<template>
  <li>
    <span class="octadesk-app-join-room">
      <span
        v-html="$sanitizeHtml($t('conversation.leave', { date: leaveDate }))"
      />
    </span>
  </li>
</template>

<script>
  import { mapGetters } from 'vuex'

  import filters from '@/filters'

  export default {
    computed: {
      ...mapGetters(['chat']),
      leaveDate() {
        return filters.DateFilters.format(this.chat.leave.time, 'LLL')
      }
    }
  }
</script>

<style></style>
